/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 54,
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      width="72"
      height="81"
      viewBox="0 0 72 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1643_15960)">
        <path
          d="M66.7345 15.0293L40.4721 1.33978C37.667 -0.122373 34.333 -0.122376 31.5279 1.33978L5.26553 15.0293C2.03124 16.7153 0 20.0795 0 23.7505V56.7359C0 60.4068 2.03123 63.7711 5.26552 65.457L31.5279 79.1465C34.333 80.6087 37.667 80.6087 40.4721 79.1465L66.7345 65.457C69.9688 63.7711 72 60.4068 72 56.7358V23.7505C72 20.0795 69.9688 16.7153 66.7345 15.0293Z"
          fill="#DB0F16"
        />
        <path
          d="M36.8086 41.6267H30.2344L30.1992 38.0056H35.7188C36.6914 38.0056 37.4883 37.8826 38.1094 37.6365C38.7305 37.3787 39.1934 37.0096 39.498 36.5291C39.8145 36.0369 39.9727 35.4392 39.9727 34.7361C39.9727 33.9392 39.8203 33.2947 39.5156 32.8025C39.2227 32.3103 38.7598 31.9529 38.127 31.7303C37.5059 31.5076 36.7031 31.3963 35.7188 31.3963H32.0625V52.8592H26.7891V27.2654H35.7188C37.207 27.2654 38.5371 27.406 39.709 27.6873C40.8926 27.9685 41.8945 28.3963 42.7148 28.9705C43.5352 29.5447 44.1621 30.2713 44.5957 31.1502C45.0293 32.0174 45.2461 33.0486 45.2461 34.2439C45.2461 35.2986 45.0059 36.2713 44.5254 37.1619C44.0566 38.0525 43.3125 38.7791 42.293 39.3416C41.2852 39.9041 39.9668 40.2146 38.3379 40.2732L36.8086 41.6267ZM36.5801 52.8592H28.793L30.8496 48.7459H36.5801C37.5059 48.7459 38.2617 48.5994 38.8477 48.3064C39.4336 48.0017 39.8672 47.5916 40.1484 47.076C40.4297 46.5603 40.5703 45.9685 40.5703 45.3006C40.5703 44.5506 40.4414 43.9002 40.1836 43.3494C39.9375 42.7986 39.5391 42.3767 38.9883 42.0838C38.4375 41.7791 37.7109 41.6267 36.8086 41.6267H31.7285L31.7637 38.0056H38.0918L39.3047 39.4295C40.8633 39.406 42.1172 39.6814 43.0664 40.2556C44.0273 40.8181 44.7246 41.5506 45.1582 42.4529C45.6035 43.3553 45.8262 44.3221 45.8262 45.3533C45.8262 46.9939 45.4688 48.3767 44.7539 49.5017C44.0391 50.615 42.9902 51.4529 41.6074 52.0154C40.2363 52.5779 38.5605 52.8592 36.5801 52.8592Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1643_15960">
          <rect width="72" height="81" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LogoIcon;
